import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {StorageService} from 'src/app/services/storage.service';
import {MatDialogRef} from '@angular/material/dialog';
import {TranslatePipe} from "@ngx-translate/core";
import {MatCheckbox} from "@angular/material/checkbox";
import {FormsModule} from "@angular/forms";
import {MatButton} from "@angular/material/button";

@Component({
    selector: 'app-recommendation-filter',
    templateUrl: './recommendation-filter.component.html',
    imports: [
        TranslatePipe,
        MatCheckbox,
        FormsModule,
        MatButton
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./recommendation-filter.component.scss']
})
export class RecommendationFilterComponent implements OnInit {

    showOnlyGood: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<RecommendationFilterComponent>,
        public storage: StorageService) {
    }

    ngOnInit(): void {
        this.showOnlyGood = this.storage.getShowOnlyGood();
    }

    closeFilterDialog(save: boolean) {
        if (save) {
            this.storage.setShowOnlyGood(this.showOnlyGood);
        }

        this.dialogRef.close();
    }

}
